import { render, staticRenderFns } from "./MatchLater.vue?vue&type=template&id=b1aed984&"
import script from "./MatchLater.vue?vue&type=script&lang=js&"
export * from "./MatchLater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports